import { Flex, Skeleton, Box } from "@radix-ui/themes";

type Props = {
  isLoading: boolean;
  numRows?: number;
};

export const TableLoading = ({ isLoading, numRows = 5 }: Props) => {
  return (
    <Flex direction="column" gap="2">
      {Array.from({ length: numRows }).map((_, i) => (
        <Skeleton key={i} loading={isLoading}>
          <Box style={{ height: "var(--space-6)" }} />
        </Skeleton>
      ))}
    </Flex>
  );
};
